import { DateTimeHelper, DateTimeType } from '../utils/date-time-helper';
import { ActivityLogStatusNumber } from '../constant/activity-log-constants';
import { StatusLookup } from './StatusLookup';

export class ActivityLog {
    RecordId?: number;

    Id?: number;
    CreatedBy?: number;
    CreatedDate?: string;
    ModifiedBy?: number;
    ModifiedDate?: string;

    UserId: number;
    ProjectId: number;
    ActivityDate: string;
    StatusLookupId: number;
    IsDeleted: boolean;

    SubmittedBy?: number;
    SubmittedDate?: string;
    SubmittedDateOffset?: number;
    SubmittedTimeZoneId?: string;
    Signature?: string;

    VerifiedBy?: number;
    VerifiedDate?: string;
    VerifiedDateOffset?: number;
    VerifiedTimeZoneId?: string;
    VerifiedSignature?: number;

    ApprovedBy?: number;
    ApprovedDate?: string;
    ApprovedDateOffset?: number;
    ApprovedTimeZoneId?: string;
    ApprovedSignature?: number;

    ReturnedBy?: number;
    ReturnedDate?: string;
    ReturnedDateOffset?: number;
    ReturnedTimeZoneId?: string;
    Remarks?: string;

    PrintedDate?: string;
    PrintedDateOffset?: number;

    constructor(obj?: Partial<ActivityLog>) {
		if (obj) {
				Object.assign(this, obj);
		}
		else {
			throw Error('Object cannot be null');
		}
	}
    
    clone(): ActivityLog {
        return new ActivityLog(this);
    }

    setToOpen(statusLookup: StatusLookup): void {
        if (statusLookup.Number !== ActivityLogStatusNumber.Open) {
            throw new Error("Status must be Open");
        }

        this.StatusLookupId = statusLookup.Id;
        this.clearReturnedFields();
        this.clearSubmittedFields();
        this.clearVerifiedFields();
        this.clearApprovedFields();
    }

    setToReturned(statusLookup: StatusLookup, returnedBy: number, returnedDate: DateTimeType, returnedTimeZoneId: string, remarks: string): void {
        if (statusLookup.Number !== ActivityLogStatusNumber.Returned) {
            throw new Error("Status must be Returned");
        }

        this.StatusLookupId = statusLookup.Id;
        this.ReturnedBy = returnedBy;
        this.ReturnedDate = DateTimeHelper.formatDateTime(returnedDate);
        this.ReturnedDateOffset = DateTimeHelper.getUtcOffsetInMinutes(returnedDate, returnedTimeZoneId);
        this.ReturnedTimeZoneId = returnedTimeZoneId;
        this.Remarks = remarks;

        this.clearSubmittedFields();
        this.clearVerifiedFields();
        this.clearApprovedFields();
    }

    setToSubmitted(statusLookup: StatusLookup, submittedBy: number, submittedDate: DateTimeType, submittedTimeZoneId: string, signature: string): void {
        if (statusLookup.Number !== ActivityLogStatusNumber.Submitted) {
            throw new Error("Status must be Submitted");
        }

        this.StatusLookupId = statusLookup.Id;
        this.SubmittedBy = submittedBy;
        this.SubmittedDate = DateTimeHelper.formatDateTime(submittedDate);
        this.SubmittedDateOffset = DateTimeHelper.getUtcOffsetInMinutes(submittedDate, submittedTimeZoneId);
        this.SubmittedTimeZoneId = submittedTimeZoneId;
        this.Signature = signature;

        this.clearReturnedFields();
        this.clearVerifiedFields();
        this.clearApprovedFields();
    }

    setToVerified(statusLookup: StatusLookup, verifiedBy: number, verifiedDate: DateTimeType, verifiedTimeZoneId: string, verifiedSignature: number): void {
        if (statusLookup.Number !== ActivityLogStatusNumber.Verified) {
            throw new Error("Status must be Verified");
        }

        this.StatusLookupId = statusLookup.Id;
        this.VerifiedBy = verifiedBy;
        this.VerifiedDate = DateTimeHelper.formatDateTime(verifiedDate);
        this.VerifiedDateOffset = DateTimeHelper.getUtcOffsetInMinutes(verifiedDate, verifiedTimeZoneId);
        this.VerifiedTimeZoneId = verifiedTimeZoneId;
        this.VerifiedSignature = verifiedSignature;

        this.clearReturnedFields();
        this.clearApprovedFields();
    }

    setToApproved(statusLookup: StatusLookup, approvedBy: number, approvedDate: DateTimeType, approvedTimeZoneId: string, approvedSignature: number): void {
        if (statusLookup.Number !== ActivityLogStatusNumber.Approved) {
            throw new Error("Status must be Approved");
        }

        this.StatusLookupId = statusLookup.Id;
        this.ApprovedBy = approvedBy;
        this.ApprovedDate = DateTimeHelper.formatDateTime(approvedDate);
        this.ApprovedDateOffset = DateTimeHelper.getUtcOffsetInMinutes(approvedDate, approvedTimeZoneId);
        this.ApprovedTimeZoneId = approvedTimeZoneId;
        this.ApprovedSignature = approvedSignature;

        this.clearReturnedFields();
    }

    setSoftDeleted(): void {
        this.IsDeleted = true;
    }

    private clearReturnedFields(): void {
        this.ReturnedBy = null;
        this.ReturnedDate = null;
        this.ReturnedDateOffset = null;
        this.ReturnedTimeZoneId = null;
        this.Remarks = null;
    }

    private clearSubmittedFields(): void {
        this.SubmittedBy = null;
        this.SubmittedDate = null;
        this.SubmittedDateOffset = null;
        this.SubmittedTimeZoneId = null;
        this.Signature = null;
    }

    private clearVerifiedFields(): void {
        this.VerifiedBy = null;
        this.VerifiedDate = null;
        this.VerifiedDateOffset = null;
        this.VerifiedTimeZoneId = null;
        this.VerifiedSignature = null;
    }

    private clearApprovedFields(): void {
        this.ApprovedBy = null;
        this.ApprovedDate = null;
        this.ApprovedDateOffset = null;
        this.ApprovedTimeZoneId = null;
        this.ApprovedSignature = null;
    }

    get Date(): string {
        return DateTimeHelper.formatDateTimeAsDate(this.ActivityDate);
    }
}